export default {
  title: 'Betal med {{method}}',
  hint: 'Derefter bekræfter du betalingen hos din bank eller i din app.',
  continue: 'Fortsæt',
  cancel: 'Annuller betaling',
  unavailable: 'Denne betalingsmetode er ikke tilgængelig lige nu. Vælg en anden.',
};
